document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("search-input");
  const resultsBox = document.getElementById("predictive-results");
  const typeSelect = document.querySelector(".search-category"); 

  if (!input) return;

  input.addEventListener("input", function () {
    const query = input.value.trim();
    const type = typeSelect.value; 

    if (query.length < 2) {
      resultsBox.style.display = "none";
      return;
    }

    let resourceTypes = type === "all" ? "product,article,page" : type;

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=${resourceTypes}&resources[limit]=5`)
      .then(res => res.json())
      .then(data => {
        let results = "";

        if (data.resources.results.products?.length) {
          results += "<ul>";
          data.resources.results.products.forEach(product => {
            results += `
              <li class="search-result-item" data-title="${product.title}">
                <a href="#" class="product-result">
                  <img src="${product.image}" width="40" style="margin-right:10px;" />
                  ${product.title}
                </a>
              </li>`;
          });
          results += "</ul>";
        }

        if (data.resources.results.articles?.length) {
          results += "<ul>";
          data.resources.results.articles.forEach(article => {
            results += `
              <li>
                <a href="${article.url}">
                  ${article.title}
                </a>
              </li>`;
          });
          results += "</ul>";
        }

        if (!results) {
          results = "<p style='padding:10px;'>No results found</p>";
        }

        resultsBox.innerHTML = results;
        resultsBox.style.display = "block";

        document.querySelectorAll(".search-result-item").forEach(item => {
          item.addEventListener("click", (e) => {
            e.preventDefault();
            const productTitle = item.dataset.title;

            const productElement = Array.from(document.querySelectorAll(".product-card-title"))
              .find(el => el.textContent.trim() === productTitle);

            if (productElement) {
              // productElement.scrollIntoView({ behavior: "smooth", block: "start" });

              // productElement.style.transition = "background-color 1s";
              // productElement.style.backgroundColor = "yellow";

              // setTimeout(() => {
              //   productElement.style.backgroundColor = "";
              // }, 2000);

                const popupTrigger = productElement.closest(".newFeatured-product-item")?.querySelector(".popup-trigger");
                if (popupTrigger) {
                  popupTrigger.click();
                }

              resultsBox.style.display = "none";
              input.value = ""; 
            }
          });
        });
      })
      .catch(err => {
        console.error("Predictive search error:", err);
      });
  });

  document.addEventListener("click", function (e) {
    if (!resultsBox.contains(e.target) && e.target !== input) {
      resultsBox.style.display = "none";
    }
  });
});
